module.exports = __webpack_public_path__ + "static/img/cscj-Bu9rl2Yg.779a635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/cscj-Bu9rl2Yg.png
// module id = C1vp
// module chunks = 16